import {css} from 'styled-components'
import ucfirst from 'ucfirst'
import media from '../utils/media'

const sizeClasses = ['xs', 'sm', 'md', 'lg', 'xl']

export const cssHelpersProps = sizeClasses.map(sizeClass => {
  const s = (sizeClass === 'xs' ? '' : ucfirst(sizeClass))

  return [
    `flex${s}Row`,
    `flex${s}Column`,
    `flex${s}RowReverse`,
    `flex${s}ColumnReverse`,
    `flex${s}Wrap`,
    `flex${s}Nowrap`,
    `flex${s}WrapReverse`,
    `justifyContent${s}Start`,
    `justifyContent${s}End`,
    `justifyContent${s}Center`,
    `justifyContent${s}Between`,
    `justifyContent${s}Around`,
    `alignItems${s}Start`,
    `alignItems${s}End`,
    `alignItems${s}Center`,
    `alignItems${s}Baseline`,
    `alignItems${s}Stretch`,
    `alignContent${s}Start`,
    `alignContent${s}End`,
    `alignContent${s}Center`,
    `alignContent${s}Between`,
    `alignContent${s}Around`,
    `alignContent${s}Stretch`,
    `alignSelf${s}Auto`,
    `alignSelf${s}Start`,
    `alignSelf${s}End`,
    `alignSelf${s}Center`,
    `alignSelf${s}Baseline`,
    `alignSelf${s}Stretch`,
  ]
}).reduce((acc, val) => acc.concat(val), [])

export default props =>
  sizeClasses.map(sizeClass => {
    const s = (sizeClass === 'xs' ? '' : ucfirst(sizeClass))

    const flexRow               = props[`flex${s}Row`]
    const flexColumn            = props[`flex${s}Column`]
    const flexRowReverse        = props[`flex${s}RowReverse`]
    const flexColumnReverse     = props[`flex${s}ColumnReverse`]
    const flexWrap              = props[`flex${s}Wrap`]
    const flexNowrap            = props[`flex${s}Nowrap`]
    const flexWrapReverse       = props[`flex${s}WrapReverse`]
    const justifyContentStart   = props[`justifyContent${s}Start`]
    const justifyContentEnd     = props[`justifyContent${s}End`]
    const justifyContentCenter  = props[`justifyContent${s}Center`]
    const justifyContentBetween = props[`justifyContent${s}Between`]
    const justifyContentAround  = props[`justifyContent${s}Around`]
    const alignItemsStart       = props[`alignItems${s}Start`]
    const alignItemsEnd         = props[`alignItems${s}End`]
    const alignItemsCenter      = props[`alignItems${s}Center`]
    const alignItemsBaseline    = props[`alignItems${s}Baseline`]
    const alignItemsStretch     = props[`alignItems${s}Stretch`]
    const alignContentStart     = props[`alignContent${s}Start`]
    const alignContentEnd       = props[`alignContent${s}End`]
    const alignContentCenter    = props[`alignContent${s}Center`]
    const alignContentBetween   = props[`alignContent${s}Between`]
    const alignContentAround    = props[`alignContent${s}Around`]
    const alignContentStretch   = props[`alignContent${s}Stretch`]
    const alignSelfAuto         = props[`alignSelf${s}Auto`]
    const alignSelfStart        = props[`alignSelf${s}Start`]
    const alignSelfEnd          = props[`alignSelf${s}End`]
    const alignSelfCenter       = props[`alignSelf${s}Center`]
    const alignSelfBaseline     = props[`alignSelf${s}Baseline`]
    const alignSelfStretch      = props[`alignSelf${s}Stretch`]

    return media[sizeClass]`
      ${flexRow && css`
        flex-direction: row;
      `}

      ${flexColumn && css`
        flex-direction: column;
      `}

      ${flexRowReverse && css`
        flex-direction: row-reverse;
      `}

      ${flexColumnReverse && css`
        flex-direction: column-reverse;
      `}

      ${flexWrap && css`
        flex-wrap: wrap;
      `}

      ${flexNowrap && css`
        flex-wrap: nowrap;
      `}

      ${flexWrapReverse && css`
        flex-wrap: wrap-reverse;
      `}

      ${justifyContentStart && css`
        justify-content: flex-start;
      `}

      ${justifyContentEnd && css`
        justify-content: flex-end;
      `}

      ${justifyContentCenter && css`
        justify-content: center;
      `}

      ${justifyContentBetween && css`
        justify-content: space-between;
      `}

      ${justifyContentAround && css`
        justify-content: space-around;
      `}

      ${alignItemsStart && css`
        align-items: flex-start;
      `}

      ${alignItemsEnd && css`
        align-items: flex-end;
      `}

      ${alignItemsCenter && css`
        align-items: center;
      `}

      ${alignItemsBaseline && css`
        align-items: baseline;
      `}

      ${alignItemsStretch && css`
        align-items: stretch;
      `}

      ${alignContentStart && css`
        align-content: flex-start;
      `}

      ${alignContentEnd && css`
        align-content: flex-end;
      `}

      ${alignContentCenter && css`
        align-content: center;
      `}

      ${alignContentBetween && css`
        align-content: space-between;
      `}

      ${alignContentAround && css`
        align-content: space-around;
      `}

      ${alignContentStretch && css`
        align-content: stretch;
      `}

      ${alignSelfAuto && css`
        align-self: auto;
      `}

      ${alignSelfStart && css`
        align-self: flex-start;
      `}

      ${alignSelfEnd && css`
        align-self: flex-end;
      `}

      ${alignSelfCenter && css`
        align-self: center;
      `}

      ${alignSelfBaseline && css`
        align-self: baseline;
      `}

      ${alignSelfStretch && css`
        align-self: stretch;
      `}
    `
  })



// WEBPACK FOOTER //
// ./src/utils/cssHelpers.js